import _ from 'lodash';
import math from '../../util/math';
import { ERROR, LOADING, SUCCESS, RESET, ALL_LOADED, SUCCESS_WIP_BREAKDOWN, LOADING_WIP_BREAKDOWN } from './CTAActions';

const INITIAL_STATE = {
  allLoaded: false,
  isLoading: false,
  success: false,
  error: '',
  data: [],
  hash: '',
  wipBreakdown: [],
  wipBreakdownLoading: false,
};

const CTAReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case RESET: {
      return { ...state, allLoaded: false, data: [], wipBreakdown: [] };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: [...state.data, action.data] };
    }
    case ALL_LOADED: {
      return { ...state, allLoaded: true };
    }
    case SUCCESS_WIP_BREAKDOWN: {
      return { ...state, wipBreakdown: action.data };
    }
    case LOADING_WIP_BREAKDOWN: {
      return { ...state, wipBreakdownLoading: action.loading };
    }
    default:
      return state;
  }
};

export default CTAReducer;
